import { TimeValidationError } from "./TimeValidationError";
import { TimeValidationResult } from "./TimeValidationResult";

const EMPTY_REGEX = /^\s*$/;
const DAILY_REGEX = /^(?<days>\d+)d?$/;

export const validateDailyFormattedTime = (
  formattedTime: string,
  onSuccess: (result: TimeValidationResult) => void,
  onError: (error: TimeValidationError) => void,
) => {
  const input = formattedTime.trim();

  const emptyMatch = EMPTY_REGEX.exec(input);
  if (emptyMatch !== null) {
    return onSuccess({
      reportedTime: 0,
      input: "",
    });
  }

  const dailyMatch = DAILY_REGEX.exec(input);
  if (dailyMatch !== null && typeof dailyMatch.groups?.days === "string") {
    const days = Number.parseInt(dailyMatch.groups?.days, 10);

    if (days > 1) {
      return onError("MAX_ONE_DAY");
    }

    return onSuccess({
      reportedTime: days,
      input,
    });
  }

  return onError("WRONG_FORMAT");
};
